import {event} from '../vendor/dynamicyield/dynamicyield.js';
import {parse} from '../smartpak/cookie.js';

const DEFAULT_ZIPCODE = '02360',
    preferredLocationCookie = parse('PreferredLocation', function(cookie) {
        cookie.PreferredZipCode = cookie.PreferredZipCode ? cookie.PreferredZipCode : DEFAULT_ZIPCODE;
    });

event('Preferred Location', preferredLocationCookie);

export default preferredLocationCookie;
